import { createReducer, on } from '@ngrx/store';
import { OsUpdatesApiActions } from './available-os-updates.actions';
import { adapter, initialState } from './available-os-updates.state';

export const availableOsUpdatesFeatureKey = 'available-osupdates';

export const AvailableOsUpdatesReducer = createReducer(
  initialState,
  on(OsUpdatesApiActions.availableOsUpdatesLoaded, (state, { availableOsUpdates }) =>
    adapter.upsertMany(availableOsUpdates, state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectAvailableOsUpdateIds = selectIds;

export const selectAvailableOsUpdateEntities = selectEntities;

export const selectAllAvailableOsUpdates = selectAll;
